import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Layout from "../components/layout/Layout";
import "./UserDashboard.css";

export default function UserDashboard() {
  const navigate = useNavigate();

  const API = "https://data.shreemwell.in/api/contacts";

  const [activeTab, setActiveTab] = useState("today");
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBirthdays(activeTab);
  }, [activeTab]);

  const fetchBirthdays = async (type) => {
    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const res = await axios.get(
        `${API}/birthday-dashboard?type=${type}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setContacts(res.data.data);
      } else {
        setContacts([]);
      }
    } catch (error) {
      console.log(error);
      setContacts([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout role="user">
      <div className="container-fluid py-4">

        {/* Top Header */}

        <div className="dashboard-top">

          <div>
            <h2 className="dashboard-title">
               Dashboard
            </h2>

            <p className="dashboard-subtitle">
              View today's, this week's and this month's birthdays.
            </p>
          </div>

          <button
            className="add-contact-btn"
            onClick={() => navigate("/ContactMangement")}
          >
            + Add Contact
          </button>

        </div>

        {/* Birthday Card */}
        <div className="birthday-card-wrapper">

        <div className="birthday-card shadow">

          {/* Header */}

          <div className="birthday-header">

            <h3>
              🎂 Birthday Dashboard
            </h3>

            <div className="birthday-tabs">

              <button
                className={activeTab === "today" ? "active-tab" : ""}
                onClick={() => setActiveTab("today")}
              >
                Today
              </button>

              <button
                className={activeTab === "week" ? "active-tab" : ""}
                onClick={() => setActiveTab("week")}
              >
                This Week
              </button>

              <button
                className={activeTab === "month" ? "active-tab" : ""}
                onClick={() => setActiveTab("month")}
              >
                This Month
              </button>

            </div>

          </div>

          {/* Body */}

          <div className="birthday-body">

            {loading ? (
              <div className="loading-box">

                <div
                  className="spinner-border text-primary"
                  role="status"
                />

                <h5 className="mt-3">
                  Loading Birthdays...
                </h5>

              </div>
            ) : contacts.length === 0 ? (
              <div className="empty-box">

                <div className="empty-icon">
                  🎂
                </div>

                <h4>No Birthdays Found</h4>

                <p>
                  No contacts available for the selected period.
                </p>

              </div>
            ) : (
              <div className="table-scroll">

                <table className="table birthday-table">

                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>Date of Birth</th>
                      <th>Current Location</th>
                    </tr>
                  </thead>

                  <tbody>
                                        {contacts.map((contact) => (
                      <tr
                        key={contact._id}
                        className="birthday-row"
                        onClick={() =>
                          navigate(`/view-contact/${contact._id}`)
                        }
                      >
                        <td>
                          <div className="person-info">

                         
                            <div className="person-details">

                              <h6>
                                {contact.firstName} {contact.lastName}
                              </h6>

                              {contact.nickname && (
                                <small>
                                  {contact.nickname}
                                </small>
                              )}

                            </div>

                          </div>
                        </td>

                        <td>
                          {contact.mobile || "-"}
                        </td>

                        <td>
                          {contact.dateOfBirth
                            ? new Date(
                                contact.dateOfBirth
                              ).toLocaleDateString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })
                            : "-"}
                        </td>

                        <td>
                          {contact.currentLocation || "-"}
                        </td>

                      </tr>
                    ))}
                  </tbody>

                </table>

              </div>
            )}

          </div>

        </div>
        </div>

      </div>
    </Layout>
  );
}